
import React from "react";
import { CellProps, Table, Whisper, Popover } from "rsuite";

const { Cell } = Table;

interface ImageCellProps extends CellProps<any> {
  dataKey: string;
}

const getNestedValue = (obj: any, path: string) =>
  path.split(".").reduce((value, key) => value?.[key], obj);

const ImageCell: React.FC<ImageCellProps> = ({ dataKey, ...props }) => {
  const imageUrl = getNestedValue(props.rowData, dataKey);

  if (!imageUrl) return <Cell {...props} />;

  return (
    <Cell {...props} style={{ padding: 8 }}>
      <Whisper
        trigger="hover"
        placement="right"
        speaker={
          <Popover
            style={{
              padding: 10,
              width: 350,
              height: 'auto',
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              overflow: "hidden",
              borderRadius: 8
            }}
          >
            <img
              src={imageUrl}
              style={{
                maxWidth: "100%",
                maxHeight: "100%", // ensures no overflow for vertical images
                objectFit: "contain",
                borderRadius: 6
              }}
            />
          </Popover>
        }
      >
        <div
          style={{
            height: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            overflow: "hidden",
            cursor: "zoom-in"
          }}
        >
          <img
            src={imageUrl}
            style={{
              height: "100%",
              width: "auto",
              maxHeight: "100%",
              borderRadius: 5,
              objectFit: "cover"
            }}
          />
        </div>
      </Whisper>
    </Cell>
  );
};

export default ImageCell;
